import { State } from "../core/src/states/State";
import ViewManager from "../core/src/utils/ViewManager";
import { DefaultLayers } from "../core/src/utils/Layers";
import SceneView from "../core/src/views/SceneView";
import PointerEvents from "../core/src/const/PointerEvents";
import CommandManager from "../core/src/commands/CommandManager";
import { VendorCommandsEnum } from "../src/commands/VendorCommandsEnum";
import Locale from "../core/src/utils/Locale";
import VendorModel, { IFreeGamesBetOption } from "../server/model/VendorModel";
import GameModel from "../core/src/model/GameModel";
import BetModel from "../core/src/model/BetModel";
import UIController from "../core/src/ui/UIController";
import { UIModes, UIStates } from "../core/src/ui/UIStates";
import SwitchButton from "../core/src/views/components/SwitchButton";
import AutoplayModel from "../core/src/model/AutoplayModel";
import { UIUpdateEvent } from "../core/src/ui/UIUpdateEvents";
import { TweenMax } from 'gsap';
import ConsoleUtil from '../core/src/utils/ConsoleUtil';
import { Commands } from '../core/src/commands/CommandEnum';

const LOG_COLOR = 0xf59b42;

export default class RelaxFreeGamesAwardedState extends State {
    protected scene: SceneView;
    protected selectedVal: number;
    protected expiredDelayExit: TweenMax;

    enter() {
        super.enter();
        UIController.setState(UIStates.IDLE);

        // this.scene:SceneView;
        if (
            VendorModel.freeGames.betSizeOptions &&
            VendorModel.freeGames.betSizeOptions.length
        ) {
            this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
                "freeGamesAwardedMultyChoice"
            );
            let btnGroup = this.scene.buttonGroups.get("choice");
            this.scene.buttons.get("ok").setEnabled(false);
            btnGroup.getChildren().forEach((btn) => {
                btn.setVisible(false);
            });
            VendorModel.freeGames.betSizeOptions.forEach((value, index) => {
                let btn = this.scene.buttons.get(
                    "choice~" + (index + 1)
                ) as SwitchButton;
                btn.setVisible(true);
                // btn["bet"] = value.ba;
                let msgPatternReplace = [];
                msgPatternReplace.push(
                    value.spins,
                    BetModel.formatCurrency(
                        value.ba,
                        GameModel.gameConfig.defaultCurrencyFormat
                    )
                );
                let text = Locale.getString(
                    "gui_free_games_data",
                    msgPatternReplace
                );
                btn.setValue(JSON.stringify(value), text);
            });

            if (this.scene.sceneTextFields.has("text")) {
                this.scene.sceneTextFields.get("text").text = Locale.getString("");
            }
            btnGroup.onSelect((val: string) => {
                let valObj: IFreeGamesBetOption = JSON.parse(val);
                this.selectedVal = valObj.ba;
                VendorModel.freeGames.spins = valObj.spins;
                VendorModel.freeGames.ba = valObj.ba;
                this.scene.buttons.get("ok").setEnabled(true);
            });
        } else {
            this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
                "freeGamesAwarded"
            );
            let msgPatternReplace = [];
            msgPatternReplace.push(
                VendorModel.freeGames.spins,
                BetModel.formatCurrency(
                    VendorModel.freeGames.ba,
                    GameModel.gameConfig.defaultCurrencyFormat
                )
            );
            this.scene.sceneTextFields.get("text").text = Locale.getString(
                "gui_free_games_data",
                msgPatternReplace
            );
        }
        this.scene.sceneTextFields.get("title").text = Locale.getString(
            "gui_congratulations"
        );
        ViewManager.getLayer("SplashOverlay").setScene("open");
        BetModel.setStake(null, VendorModel.freeGames.ba);
        this.scene.buttons.get("ok").on(PointerEvents.DOWN, () => {
            CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS)
            // if(VendorModel.freeGames.betSizeOptions) {

            // }
            VendorModel.enterFreeGames();
            UIController.setMode(UIModes.PROMOTION_SPINS);
            // UIController.setState(UIStates.IDLE);
            UIController.updateFields(UIUpdateEvent.FreeGames);
            // if(VendorModel.freeGames.betSizeOptions) {
            //     this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("freeGamesAwardedMultyChoice");
            //     // let btnGroup = this.scene.buttonGroups.get("choice");
            //     // btnGroup.
            //     VendorModel.freeGames.ba = this.selectedVal;
            // }
            if (VendorModel.freeGames.autoplay) {
                AutoplayModel.setAutoSpin(VendorModel.freeGames.spins);
                AutoplayModel.startAutoSpin();
            }
            this.exit();
        });

        this.scene.buttons.get("cancel").on(PointerEvents.DOWN, () => {
            CommandManager.execute(VendorCommandsEnum.CANCEL_FREE_GAMES);
            this.exit();
        });

        this.scene.buttons.get("skip").on(PointerEvents.DOWN, () => {
            CommandManager.execute(VendorCommandsEnum.SKIP_FREE_GAMES);
            this.exit();
        });

        // Set timer for expire
        if (VendorModel.freeGames.expires) {
            let msRemaining =
                new Date(VendorModel.freeGames.expires * 1000).getTime() -
                new Date().getTime();

            ConsoleUtil.logWithColor(
                "[FreeGamesAwarded] Expire time: ",
                LOG_COLOR,
                new Date(VendorModel.freeGames.expires * 1000)
            );
            ConsoleUtil.logWithColor(
                "[FreeGamesAwarded] Time remaining: " + Math.round(msRemaining / 1000) + " seconds",
                LOG_COLOR
            );

            if (msRemaining <= 0) {
                this.exit();
            } else {
                this.expiredDelayExit = TweenMax.delayedCall((msRemaining / 1000) + 3, () => {
                    VendorModel.enterFreeGames();
                    this.exit();
                }, [], this);
            }
        }
    }

    exit() {
        if (this.expiredDelayExit) {
            this.expiredDelayExit.kill();
        }
        // TweenMax.killDelayedCallsTo(this.exit);

        ViewManager.getLayer(DefaultLayers.Popups).clear();
        ViewManager.getLayer("SplashOverlay").clear();
        super.exit();
    }
}
